import lodashGet from 'lodash/get';
import { getAtomTypeFromNucleus } from '../general/getAtomTypeFromNucleus';
import { addToExperiments } from './addToExperiments';
/**
 * Get "plain" 1D experiments containing ranges, i.e. without DEPT etc..
 *
 * @param {Spectra} spectraData
 */
export function getExperiments1D(experiments) {
    const _experiments1D = {};
    lodashGet(experiments, '1D.1d', [])
        .map((experiment) => getAtomTypeFromNucleus(experiment.info.nucleus))
        .forEach((atomType) => {
        addToExperiments(experiments, _experiments1D, '1D.1d', true, atomType);
    });
    return _experiments1D;
}
//# sourceMappingURL=getExperiments1D.js.map